// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/3b71761488a18fa728e6.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"fc7b88157680400e94d9","265":"6ebf7207a2a10bd046eb","266":"e90b4f6f16126f9d792c"}[chunkId] + ".chunk.js";
};